var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SelectTableDialog',{ref:"selectTableRef",attrs:{"title":this.$t('salesBill.creatDialog.title.searchOrderProductDetail'),"searchColumns":_vm.searchColumns,"columnList":_vm.columnList,"defaultVisible":_vm.defaultVisible,"confirmUnchecked":false,"API":_vm.productAPI,"extraData":{
    contractCategory: 'sales',
    contractStatus: 'ZT03',
    dataGroup: _vm.$globalVar.dataGroup,
    departmentCode: _vm.userInfo.departmentCode,
  },"propCode":"contractNo","width":"1200px"},on:{"close":_vm.close,"confirm":_vm.confirm}})
}
var staticRenderFns = []

export { render, staticRenderFns }